/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateMicroAuthCheck} from '../api'

export const useMutationInitiateMicroAuthCheck = createReactQueryMutationHook('initiateMicroAuthCheck', initiateMicroAuthCheck)
